"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/Item/RowMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);




















const ITEMS = '[role="menuitem"]'

// Rendered in a portal, but React events still bubble to the row: a click or
// right-click in the menu must not open the chat.
const stopPropagation = e => e.stopPropagation()
const keepOwnMenu = (e) => {
  e.preventDefault()
  e.stopPropagation()
}

/* The inbox row's menu (D-6): opens on its first item; arrows move and wrap,
 * Home/End jump, Escape or Tab close it back to the opener. Account → API
 * keys uses it for each key's ⋯ button too (F-17). */
const RowMenu = ({ anchorRef, items, label = 'Chat actions', onClose }) => {
  const menuRef = _react.useRef(null)

  _react.useEffect.call(void 0, () => { _optionalChain([menuRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelector, 'call', _3 => _3(ITEMS), 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()]) }, [])

  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    const buttons = [..._nullishCoalesce(_optionalChain([menuRef, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.querySelectorAll, 'call', _8 => _8(ITEMS)]), () => ( []))]
    const at = buttons.indexOf(document.activeElement )
    const move = (i) => {
      e.preventDefault()
      _optionalChain([buttons, 'access', _9 => _9[(i + buttons.length) % buttons.length], 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
    }
    if (e.key === 'ArrowDown') move(at + 1)
    else if (e.key === 'ArrowUp') move(at - 1)
    else if (e.key === 'Home') move(0)
    else if (e.key === 'End') move(buttons.length - 1)
    else if (e.key === 'Tab') onClose(true)
  }, [onClose])

  // One stable handler per item: choosing closes the menu, then acts.
  const onChoose = _react.useMemo.call(void 0, 
    () => Object.fromEntries(items.map(item => [item.key, () => {
      onClose(true)
      item.onSelect()
    }])),
    [items, onClose],
  )

  const onPopoverClose = _react.useCallback.call(void 0, (reason) => onClose(reason === 'escape'), [onClose])

  return (
    _react2.default.createElement(_Popover2.default, { anchorRef: anchorRef, onClose: onPopoverClose, align: "right", className: "inbox-row-menu", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      , _react2.default.createElement('div', {
        ref: menuRef,
        role: "menu",
        'aria-label': label,
        className: "inbox-row-menu--list",
        onKeyDown: onKeyDown,
        onClick: stopPropagation,
        onContextMenu: keepOwnMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}

        ,  items.map(item => (
          _react2.default.createElement('button', {
            key: item.key,
            type: "button",
            role: "menuitem",
            tabIndex: -1,
            className: _classBuilder2.default.call(void 0, 'inbox-row-menu--item', item.isDestructive && 'inbox-row-menu--item--destructive'),
            onClick: onChoose[item.key], __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}

            ,  item.icon && _react2.default.createElement('span', { className: "inbox-row-menu--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}},  item.icon ) 
            ,  item.label 
          )
        ))
      )
    )
  )
}

exports. default = RowMenu
